{
  "profile": {
    "name": "Mateo Cohen",
    "title": "Lead AI Product Designer",
    "yearsOfExperience": "8+",
    "currentRole": "Lead AI Product Designer (NDA project featured at AWS re:Invent 2025)",
    "secondaryRoles": [
      "AI Trainer at Mercor",
      "AI Strategy Collaborator",
      "Prompt Engineer"
    ],
    "locations": {
      "primary": "Cleveland, OH",
      "workLocation": "Remote for Chicago-based company",
      "additionalLocations": ["Chicago, IL", "Pittsburgh, PA"]
    },
    "availability": {
      "status": "Free agent starting January 1, 2026",
      "openToRelocation": true,
      "relocationNote": "Open to relocation if compensation package allows for comfortable lifestyle based on city's cost of living"
    },
    "contact": {
      "email": "mateo.cohen9@gmail.com",
      "linkedin": "linkedin.com/in/mateo-aistrategist",
      "youtube": "youtube.com/@somedesignerguy"
    },
    "bioSummary": "Seasoned designer with nearly a decade of experience in Product Design. Specialized in AI integration, user interface design, and prototyping. Currently leading an AI design team (NDA project) featured at AWS re:Invent 2025. Collaborating with Amazon on a white paper regarding work at Case Western Reserve University (coming 2026)."
  },

  "coreSkills": {
    "aiStrategy": {
      "category": "AI Strategy & Innovation",
      "skills": [
        "AI integration strategies",
        "Intelligent automation",
        "Data-driven insights",
        "Conversational AI design",
        "AI-powered solutions",
        "Platform evaluation (Watson, Dialogflow, Microsoft, Amazon)",
        "Agentic AI development (learning)",
        "Prompt engineering"
      ]
    },
    "uxDesign": {
      "category": "UX Design",
      "skills": [
        "User research",
        "Wireframing",
        "Prototyping",
        "Usability testing",
        "Accessibility (WCAG AA)",
        "User-centered design",
        "Qualitative research",
        "Affinity diagramming",
        "Contextual inquiry",
        "Card sorting",
        "Tree testing"
      ]
    },
    "uiDesign": {
      "category": "UI Design",
      "skills": [
        "Visual design",
        "Design systems",
        "Interaction design",
        "Typography",
        "Interface design",
        "Responsive design",
        "Mobile-first design"
      ]
    },
    "engineering": {
      "category": "Engineering & Technical",
      "skills": [
        "HTML",
        "CSS",
        "JavaScript",
        "Python (currently learning)",
        "Agentic AI development",
        "Front-end collaboration with developers"
      ]
    }
  },

  "tools": {
    "design": ["Figma", "Sketch", "Adobe XD", "Adobe Creative Suite"],
    "prototyping": ["Magic Patterns", "ProtoPie", "Various prototyping tools"],
    "ai": ["Watson", "Dialogflow", "GPT", "AI Agents"],
    "development": ["HTML", "CSS", "JavaScript", "Python (learning)"]
  },

  "achievements": [
    {
      "metric": "8+ years",
      "description": "Professional design experience",
      "context": "Nearly a decade in Product Design"
    },
    {
      "metric": "AWS re:Invent 2025",
      "description": "Current NDA project featured at AWS re:Invent 2025",
      "context": "Leading AI design team"
    },
    {
      "metric": "Amazon White Paper 2026",
      "description": "Work at Case Western Reserve University featured in Amazon white paper",
      "context": "AI innovation collaboration with Amazon"
    },
    {
      "metric": "98% satisfaction",
      "description": "Customer satisfaction at US Bank - 98% rated onboarding as 'easy' or 'very easy'",
      "context": "Exceeded 90% target for One Card digital onboarding experience"
    },
    {
      "metric": "65% faster processing",
      "description": "Reduced processing time from 54 to 20 days at US Bank",
      "context": "Bank handling time from application submission to card issuance"
    },
    {
      "metric": "96% digital adoption",
      "description": "Migrated 96% of CPS pipeline to digital onboarding",
      "context": "Far surpassed 80% maintenance target across Bankcard and Transportation segments"
    },
    {
      "metric": "20,000 hours",
      "description": "Annual productivity gains unlocked at US Bank",
      "context": "Through streamlined digital solutions and automated workflows"
    },
    {
      "metric": "17+ automated processes",
      "description": "Implemented automated onboarding workflows using ServiceNow",
      "context": "High-value, reusable workflows to replicate established applications"
    },
    {
      "metric": "85%+ accuracy",
      "description": "AI CV parsing system at Case Western",
      "context": "Reduced data entry from 30 minutes to seconds"
    },
    {
      "metric": "16 interviews in 2 weeks",
      "description": "Rapid UX research sprint at Case Western",
      "context": "Comprehensive qualitative research"
    },
    {
      "metric": "75% components updated",
      "description": "Modernized outdated components at US Bank",
      "context": "Design system alignment"
    },
    {
      "metric": "20 new components",
      "description": "Created at US Bank, including vertical navigation adopted by other teams",
      "context": "Design system contribution"
    }
  ],

  "caseStudies": {
    "usBank": {
      "client": "US Bank",
      "title": "One Card Application",
      "slug": "us-bank",
      "role": "UX/UI Designer on Corporate Payment Services team",
      "projectType": "Corporate payment application redesign",
      "outcome": "Improved customer satisfaction and team productivity for Corporate Payment Services",
      "detailedImpact": [
        "Customer satisfaction: 98% rated onboarding 'easy' or 'very easy' (exceeded 90% target)",
        "Processing time: Reduced 65% from 54 days to 20 days",
        "Digital adoption: 96% of CPS pipeline migrated to digital (exceeded 80% target)",
        "Productivity: Unlocked 20,000 hours of annual productivity",
        "Automation: Implemented 17+ automated onboarding processes using ServiceNow",
        "Rapid expansion: Scaled One Card from pilot (late 2020) to full deployment across Amazon Fleet, Voyager Fleet, and U.S. Bank Canada by 2023",
        "Updated 75% of outdated components",
        "Created 20 new local components",
        "Vertical navigation adopted by other teams",
        "Partnered with accessibility specialist Tracey Jackson",
        "Ensured WCAG 2.1 AA compliance on every screen"
      ],
      "skills": ["UX/UI Design", "Financial Services", "B2B Applications", "Design Systems", "Accessibility (WCAG 2.1)", "Workflow Automation", "ServiceNow"],
      "industry": "Financial Services"
    },
    "cyberSecurity": {
      "client": "Unisys",
      "title": "Cyber Security Platform - Unisys Stealth",
      "slug": "cyber-security",
      "role": "Designer on large platform redesign",
      "projectType": "Cybersecurity platform redesign",
      "outcome": "Transformed complex micro-segmentation and threat analysis applications into intuitive solutions",
      "detailedImpact": [
        "Redesigned complex data visualization",
        "Simplified micro-segmentation workflows",
        "Made technical data accessible to security professionals",
        "Improved usability of threat analysis tools"
      ],
      "skills": ["Data Visualization", "Technical Communication", "Complex System Simplification", "Enterprise Security"],
      "industry": "Cybersecurity"
    },
    "aiComparison": {
      "client": "Financial Firm (MoneyGram)",
      "title": "Watson vs Dialogflow",
      "slug": "ai-comparison",
      "role": "Conversational AI Designer and Platform Evaluator",
      "projectType": "AI platform comparison and chatbot POC",
      "outcome": "Built conversational design POC to elevate simple tasks at call centers",
      "detailedImpact": [
        "Evaluated Watson, Dialogflow, Microsoft, Amazon platforms",
        "Built working 'Track Status' and 'Fee Lookup' demos",
        "Designed natural dialogue patterns",
        "Reduced call center volume"
      ],
      "skills": ["AI Strategy", "Conversational Design", "NLP", "Platform Evaluation", "Chatbot Design"],
      "industry": "Financial Services / AI"
    },
    "caseWestern": {
      "client": "Case Western Reserve University",
      "title": "AI Exploration & Faculty Information System",
      "slug": "case-western",
      "role": "Strategic Product Designer leading comprehensive UX/UI redesign",
      "projectType": "Faculty system redesign with AI innovation",
      "outcome": "Pilot phase project to be featured in Amazon white paper in 2026",
      "detailedImpact": [
        "Led 16 user interviews in 2-week sprint",
        "Created AI CV parsing with 85%+ accuracy",
        "Reduced data entry from 30 minutes to seconds",
        "Secured Amazon pilot program",
        "Work featured in Amazon white paper (2026)",
        "Used affinity diagramming to identify pain points"
      ],
      "skills": ["UX Research", "Product Design", "AI Innovation", "Qualitative Research", "Design Leadership"],
      "industry": "Education Technology"
    }
  },

  "testimonials": [
    {
      "name": "Alex Holder",
      "role": "Design @ Dick's Sporting Goods",
      "quote": "Mateo's vast design knowledge was so helpful... Far beyond just a designer, Mateo brings a holistic approach to product development.",
      "context": "Professional collaboration"
    },
    {
      "name": "Eric Lamontagne",
      "role": "Web Strategy Technical Lead",
      "quote": "Mateo was the TA for our UX Design Bootcamp. He always made himself available... He clearly has a deep understanding of the field.",
      "context": "Teaching and mentorship"
    },
    {
      "name": "Tracey Jackson",
      "role": "A11y Specialist, US Bank",
      "quote": "Mateo is a great person to work with and I would be happy to be a reference for him.",
      "context": "Accessibility collaboration at US Bank"
    }
  ],

  "faq": [
    {
      "q": "How many years of experience does Mateo have?",
      "a": "Mateo has 8+ years of professional design experience. He started in startups and fell into design, then pursued formal design education. Over nearly a decade, he's worked across financial services, cybersecurity, education, and fintech sectors.",
      "keywords": ["years", "experience", "how long", "how many years", "seniority", "tenure", "career length", "professional experience"]
    },
    {
      "q": "Who are you as a designer?",
      "a": "I enjoy solving tough problems and creating processes to improve efficiency. I advocate for users and believe that almost any challenge has a solution.",
      "keywords": ["philosophy", "approach", "designer", "problem solving", "who are you"]
    },
    {
      "q": "Who is Mateo outside of work?",
      "a": "I'm a family man with two boys. We love road trips, music, and spending quality time together.",
      "keywords": ["personal", "family", "outside work", "hobbies", "kids", "children", "boys", "down time", "downtime", "free time", "spare time"]
    },
    {
      "q": "How did you get into design?",
      "a": "I started in startups and fell into design. A woman at a VC pitch encouraged me to pursue it, so I applied to design school—and I'm glad I did.",
      "keywords": ["career", "started", "background", "journey", "how did you"]
    },
    {
      "q": "What drives you as a designer?",
      "a": "I'm driven by eagerness to learn new things, and my enjoyment of helping people succeed. I've been both a coach and teacher and it's the feeling I get when I watch others evolve around me that makes me feel like I've had an impact.",
      "keywords": ["motivation", "drives", "passion", "teaching", "coaching", "what drives"]
    },
    {
      "q": "How do you see AI impacting design?",
      "a": "AI is evolving rapidly. We'll collaborate more with AI agents, and synthetic user testing will become more common as users create their own AI assistants.",
      "keywords": ["ai", "future", "trends", "evolution", "impact", "ai impacting"]
    },
    {
      "q": "What do you do outside of design?",
      "a": "I spend time with my family, travel, enjoy music, and love trying new restaurants.",
      "keywords": ["hobbies", "personal", "outside", "free time", "interests", "down time", "downtime", "spare time", "fun", "enjoy"]
    },
    {
      "q": "Are you open to relocation?",
      "a": "Yes, I'm open to relocation if the compensation package allows for a comfortable lifestyle based on the city's cost of living.",
      "keywords": ["relocation", "move", "location", "willing to relocate", "open to"]
    },
    {
      "q": "Are you open to new opportunities?",
      "a": "I'm just starting to look for new opportunities and am focusing on AI in design and innovation.",
      "keywords": ["opportunities", "available", "looking", "open to", "new role"]
    },
    {
      "q": "What roles are you looking for?",
      "a": "I'd enjoy working at a funded Start-Up, Fin Tech company, Healthcare organization, Travel company, University, or any company with a complex workflow that needs simplification.",
      "keywords": ["roles", "looking for", "interested in", "ideal job", "companies", "what roles"]
    },
    {
      "q": "What's your favorite non-design skill for UX?",
      "a": "Improv! It helps me get into the mindset of different users.",
      "keywords": ["improv", "non-design", "skill", "favorite", "unique"]
    },
    {
      "q": "What are your thoughts on remote work?",
      "a": "I prefer it but I'm flexible. I've lived in six cities and adapt well, as long as the work is meaningful.",
      "keywords": ["remote", "work from home", "flexible", "thoughts on"]
    },
    {
      "q": "What's your design superpower?",
      "a": "My work ethic and continuous learning. I'm always taking classes and attending tech meetups.",
      "keywords": ["superpower", "strength", "best at", "continuous learning", "design superpower"]
    },
    {
      "q": "Can you explain your design process?",
      "a": "I was rooted in the double-diamond model but it's been evolving from: Discover, Define, Develop, and Deliver.",
      "keywords": ["process", "methodology", "approach", "double diamond", "design process"]
    },
    {
      "q": "How do you approach accessibility?",
      "a": "I follow WCAG guidelines to meet at least AA standards, ensuring proper contrast, keyboard navigation, and screen reader compatibility.",
      "keywords": ["accessibility", "a11y", "wcag", "inclusive design", "approach accessibility"]
    },
    {
      "q": "How do you conduct user research?",
      "a": "I use contextual inquiry, user interviews, usability testing, card sorting, and surveys—tailoring methods to project goals.",
      "keywords": ["user research", "research methods", "conduct research", "interviews"]
    },
    {
      "q": "What's your approach to prototyping?",
      "a": "I create low-fidelity wireframes early and high-fidelity prototypes later to validate detailed interactions before development.",
      "keywords": ["prototyping", "wireframes", "approach to", "prototype"]
    },
    {
      "q": "How do you handle mobile design?",
      "a": "I use a mobile-first approach, ensuring designs work seamlessly across all screen sizes.",
      "keywords": ["mobile", "responsive", "mobile-first", "handle mobile"]
    },
    {
      "q": "How do you create design systems?",
      "a": "I build modular components, clear guidelines, and design tokens for consistency and flexibility.",
      "keywords": ["design systems", "components", "create", "build"]
    },
    {
      "q": "How do you collaborate with developers?",
      "a": "I can speak front end with developers and that helps with handoff. I have really enjoyed problem solving with any development team I've worked with.",
      "keywords": ["developers", "collaboration", "engineering", "handoff", "collaborate"]
    },
    {
      "q": "How do you measure design success?",
      "a": "I define success metrics upfront, focusing on business outcomes and user experience (e.g., task success rate, time-on-task, satisfaction scores).",
      "keywords": ["measure", "success", "metrics", "kpi", "measure success"]
    },
    {
      "q": "How did you create your portfolio?",
      "a": "I coded my portfolio with AI assistance and actively study HTML, CSS, and JavaScript.",
      "keywords": ["portfolio", "coded", "built", "website", "create portfolio"]
    },
    {
      "q": "What design tools do you use?",
      "a": "I'm proficient in Figma, Sketch, and Adobe XD, along with advanced prototyping tools like Magic Patterns and ProtoPie.",
      "keywords": ["tools", "software", "figma", "sketch", "design tools"]
    },
    {
      "q": "What design trends are you following?",
      "a": "I keep up with AI-driven experiences and voice interfaces but always prioritize usability over trends.",
      "keywords": ["trends", "following", "current", "design trends"]
    },
    {
      "q": "How do you approach information architecture?",
      "a": "I use card sorting and tree testing to align structures with users' mental models.",
      "keywords": ["information architecture", "ia", "structure", "approach"]
    },
    {
      "q": "What's your visual design philosophy?",
      "a": "Hierarchy, consistency, and purpose.",
      "keywords": ["visual design", "philosophy", "visual", "aesthetic"]
    },
    {
      "q": "How do you design interactions?",
      "a": "I create interactions that offer clear feedback, follow patterns, and enhance usability without unnecessary complexity.",
      "keywords": ["interactions", "interaction design", "design interactions"]
    },
    {
      "q": "What does user-centered design mean to you?",
      "a": "It means involving real users at every stage, from research to testing to create experiences that truly meet their needs.",
      "keywords": ["user-centered", "ucd", "user centered", "mean to you"]
    },
    {
      "q": "How do you approach content strategy?",
      "a": "I collaborate with content strategists to align messaging with user needs, ensuring clarity and consistency.",
      "keywords": ["content strategy", "content", "messaging", "approach content"]
    },
    {
      "q": "How do you apply design thinking?",
      "a": "By empathizing with users, defining problems clearly, ideating multiple solutions, prototyping concepts, and testing continuously.",
      "keywords": ["design thinking", "apply", "methodology", "design thinking"]
    },
    {
      "q": "What's your approach to responsive design?",
      "a": "I use flexible grids, content-based breakpoints, and progressive enhancement to ensure smooth experiences across devices.",
      "keywords": ["responsive", "responsive design", "approach responsive"]
    },
    {
      "q": "How do you avoid dark patterns?",
      "a": "I advocate for ethical design, ensuring users aren't manipulated or deceived for short-term gains.",
      "keywords": ["dark patterns", "ethics", "ethical design", "avoid"]
    },
    {
      "q": "How do you handle design critiques?",
      "a": "I focus critiques on project goals and user needs, addressing usability issues objectively while acknowledging subjective preferences.",
      "keywords": ["critiques", "feedback", "handle critiques", "design critique"]
    },
    {
      "q": "What's your design leadership style?",
      "a": "I create an environment where designers can do their best work, advocate for users, and connect design to business outcomes.",
      "keywords": ["leadership", "style", "design leadership", "lead"]
    },
    {
      "q": "How do you run a design sprint?",
      "a": "I facilitate sprints to rapidly solve problems—bringing teams together to move from a challenge to a tested prototype in five days.",
      "keywords": ["design sprint", "sprint", "facilitate", "run sprint"]
    },
    {
      "q": "What is UX design to you?",
      "a": "UX design is about creating products that are practical and usable, helping people complete tasks efficiently while having a positive experience.",
      "keywords": ["ux design", "definition", "what is", "ux"]
    }
  ],

  "industries": [
    "Financial Services",
    "Cybersecurity",
    "AI/ML",
    "Education Technology",
    "Healthcare (interested)",
    "Travel (interested)",
    "Fintech (interested)",
    "Funded Startups (interested)",
    "Universities (interested)"
  ],

  "searchKeywords": {
    "ai": ["ai", "artificial intelligence", "machine learning", "chatbot", "conversational", "nlp", "watson", "dialogflow", "agentic", "prompt engineering", "synthetic testing"],
    "finance": ["finance", "financial", "banking", "payment", "us bank", "fintech", "moneygram", "corporate card"],
    "security": ["security", "cybersecurity", "cyber", "threat", "unisys", "stealth", "micro-segmentation"],
    "research": ["research", "user research", "interviews", "testing", "qualitative", "usability", "contextual inquiry", "card sorting"],
    "design": ["design", "ux", "ui", "interface", "visual", "interaction", "user-centered"],
    "accessibility": ["accessibility", "a11y", "wcag", "inclusive", "screen reader", "keyboard navigation"],
    "data": ["data", "visualization", "dashboard", "analytics", "metrics"],
    "availability": ["available", "hire", "freelance", "open to", "looking for", "opportunities"],
    "location": ["location", "where", "based", "remote", "relocation", "cleveland", "chicago", "pittsburgh"],
    "personal": ["family", "personal", "outside work", "hobbies", "kids", "children", "boys", "down time", "downtime", "free time", "spare time"],
    "process": ["process", "methodology", "approach", "double diamond", "design thinking"],
    "tools": ["tools", "figma", "sketch", "adobe", "prototyping", "software"],
    "leadership": ["leadership", "lead", "team", "mentor", "coach", "facilitate"]
  }
}